import http from "./http.js";

async function getPaymentSource(id) {
  try {
    const response = await http.get(`payment-sources/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      accountNumber: response.data.accountNumber,
      paymentType: response.data.paymentType.id,
    };
  } catch (err) {
    throw err;
  }
}

async function updatePaymentSource(id, source) {
  try {
    const response = await http.put(`payment-sources/${id}`, source);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createPaymentSource(source) {
  try {
    const response = await http.post("payment-sources", source);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getPaymentSources(page = 1, rowsPerPage = 9, search = "", filter = "") {
  try {
    const response = await http.get(
      `payment-sources?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectPaymentSource(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get(
      "payment-sources/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getPaymentSource,
  updatePaymentSource,
  createPaymentSource,
  selectPaymentSource,
  getPaymentSources,
};
